export { default, default as useTemplates } from "./useTemplates";
